const DEFAULT_CANVAS_WIDTH = 1000;
const DEFAULT_TOOLTIP_WIDTH = 1000;

export function getBackgroundImageUrl(url: string): string {
  return updateImageUrlParams(url, DEFAULT_CANVAS_WIDTH);
}

export function getCanvasDialogImageUrl(url?: string, customWidth?: number): string {
  if (!url) {
    return '';
  }
  
  return updateImageUrlParams(url, customWidth ?? DEFAULT_TOOLTIP_WIDTH);
}

function updateImageUrlParams(url: string, width: number): string {
  try {
    const urlObj = new URL(url);
    
    // Set or update the specific parameters we need
    urlObj.searchParams.set('width', width.toString());
    urlObj.searchParams.set('format', 'webp');
    urlObj.searchParams.set('quality', '70');
    
    return urlObj.toString();
  } catch (error) {
    // Fallback au cas où l'URL n'est pas valide
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}width=${width}&format=webp&quality=70`;
  }
}
